module.exports = __webpack_public_path__ + "static/media/icon-flask-outline.dc89c123.svg";